import React from 'react';
import ReactMarkdown from 'react-markdown';

const YEAR_IDENTIFIER = '[year]';

export const Markdown = ({ children = '', ...props }) => {
  const copy = children.replace(YEAR_IDENTIFIER, new Date().getFullYear().toString());

  return <ReactMarkdown {...props}>{copy}</ReactMarkdown>;
};
